import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { defaultSpouseInfo, SpouseInfo } from "../../model/spouse_info.d";
import { defaultUser, User } from '../../model/user.d';

export interface UserState {
  data: User | null;
  isLoading: boolean;
  error: any;
}

export const initialState: { data: User | null; isLoading: boolean; error: any } = {
  data: defaultUser,
  error: null,
  isLoading: true,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    retiredOrDisabled: (state, action) => {
      state.data = {
        ...(state.data || {}),
        is_retired: action.payload,
      };
    },
    fetchUser: (state) => {
      state.isLoading = true;
    },
    cancelFetchUser: (state) => {
      state.isLoading = false;
    },
    fetchUserSuccess: (state, action: PayloadAction<User>) => {
      state.isLoading = false;
      action.payload.zip = action.payload.zip?.toString();
      action.payload.phone_number = action.payload.phone_number?.toString();
      action.payload.social_security = action.payload.social_security?.toString();
      // Do not remove the null coalescing operator below unless you fully understand the ramifications of it.
      // See commit 16cbe8c for more detail, where it was introduced.
      action.payload.spouse_social_security = action.payload.spouse_social_security?.toString() ?? "";
      state.data = action.payload;
    },
    fetchUserError: (state, action) => {
      //state.data = null;
      state.isLoading = false;
      //state.error = action.payload;
    },
    updateUser: (state, _action: PayloadAction<User>) => {
      state.isLoading = true;
    },
    clearUserError: (state) => {
      state.error = null;
    },
    updateUserComplete: (state, _action: PayloadAction<User>) => {
      state.isLoading = true;
    },
    updateSpouse: (state, _action: PayloadAction<SpouseInfo>) => {
      state.isLoading = true;
    },
    deleteSpouse: (state) => {
      state.isLoading = true;
    },
    deleteSpouseComplete: (state) => {
      state.isLoading = false;
      state.data = {
        ...state.data,
        ...defaultSpouseInfo
      }
    },
    startLoading: (state) => {
      state.isLoading = true;
    },
    doneLoading: (state) => {
      state.isLoading = false;
    },
    updateUserData: (state, action: PayloadAction<User>) => {
      state.data = {
        ...state.data,
        ...action.payload
      }
    },
    updateUserSuccess: (state, action) => {
      state.isLoading = false;
      const _isJointfiling = state.data?.is_jointfiling;
      state.data = {...state.data, ...action.payload, is_jointfiling: _isJointfiling};
    },
    updateUserError: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    resetUserError: (state) => {
      // This is a separate action from the above,
      // so listeners can register to terminal actions
      // while still being able to clear errors when related saga kicks off.
      state.isLoading = false;
      state.error = null;
    },
    resetUser: (state) => {
      state.data = null;
    }
  },
});

export default userSlice.reducer;
